var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-box" },
    [
      _c(
        "div",
        {
          staticClass: "weui-search-bar",
          class: {
            "weui-search-bar_focusing": !_vm.isCancel || _vm.currentValue,
          },
          on: { click: _vm.toSearch },
        },
        [
          _vm._t("left"),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "weui-search-bar__form",
              attrs: { action: "." },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "weui-search-bar__box" }, [
                _c("i", {
                  staticClass: "iconfont icon-sousuo-sousuofangdajing",
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentValue,
                      expression: "currentValue",
                    },
                  ],
                  ref: "input",
                  staticClass: "weui-search-bar__input",
                  attrs: {
                    maxlength: "30",
                    type: "search",
                    autocomplete: "off",
                    readonly: _vm.readonly,
                    id: `search_input_${_vm.uuid}`,
                    placeholder: _vm.placeholder,
                    required: _vm.required,
                  },
                  domProps: { value: _vm.currentValue },
                  on: {
                    focus: _vm.onFocus,
                    blur: _vm.onBlur,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.currentValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showClearBtn && _vm.currentValue,
                        expression: "showClearBtn && currentValue",
                      },
                    ],
                    staticClass: "clean-text_btn",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.clear.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../image/search/clear.png"),
                        alt: "cl",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showCancelBtn,
                  expression: "showCancelBtn",
                },
              ],
              staticClass: "weui-search-bar__cancel-btn",
              attrs: { href: "javascript:" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.cancel.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.cancelText))]
          ),
          _vm._v(" "),
          _vm._t("right"),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("tabs"),
      _vm._v(" "),
      _vm._t("match-words"),
      _vm._v(" "),
      _vm.isFixed && _vm.results.length && _vm.showCancelBtn
        ? _c(
            "div",
            { staticClass: "weui-cells vux-search_show" },
            [
              _vm._t("result-header"),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "collapse",
                      rawName: "v-collapse",
                      value: {
                        class: "history-over-cell",
                        data: ["overHistoryMaxRow", "isHistoryCollapsed"],
                      },
                      expression:
                        "{class: 'history-over-cell', data: ['overHistoryMaxRow', 'isHistoryCollapsed']}",
                    },
                  ],
                  staticClass: "weui-cell-container",
                },
                [
                  _vm._l(_vm.results, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "weui-cell weui-cell_access",
                        on: {
                          click: function ($event) {
                            return _vm.handleResultClick(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "weui-cell__bd weui-cell_primary" },
                          [
                            _c("p", { staticClass: "weui-cell__item" }, [
                              _c("span", [_vm._v(_vm._s(item))]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.overHistoryMaxRow,
                          expression: "overHistoryMaxRow",
                        },
                      ],
                      class: [_vm.isHistoryCollapsed ? "btn-hide" : "btn-show"],
                      on: {
                        click: function ($event) {
                          return _vm.toggleCollapsed(
                            "history-over-cell",
                            "isHistoryCollapsed"
                          )
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "collapsed-icon",
                        attrs: {
                          src: require("../../image/search/arrow-down.png"),
                          width: "12px",
                          height: "7px",
                        },
                      }),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _vm._t("result-footer"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFixed &&
      _vm.isShowHotwords &&
      _vm.hotWords.length &&
      _vm.showCancelBtn
        ? _c(
            "div",
            { staticClass: "weui-cells vux-search_show" },
            [
              _vm._t("hot-words-header"),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "collapse",
                      rawName: "v-collapse",
                      value: {
                        class: "hot-over-cell",
                        data: ["overHotMaxRow", "isHotCollapsed"],
                      },
                      expression:
                        "{class: 'hot-over-cell', data: ['overHotMaxRow', 'isHotCollapsed']}",
                    },
                  ],
                  staticClass: "weui-cell-container",
                },
                [
                  _vm._l(_vm.hotWords, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "weui-cell weui-cell_access",
                        on: {
                          click: function ($event) {
                            return _vm.handleResultClick(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "weui-cell__bd weui-cell_primary" },
                          [
                            _c("p", { staticClass: "weui-cell__item" }, [
                              _c("span", [_vm._v(_vm._s(item))]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.overHotMaxRow,
                          expression: "overHotMaxRow",
                        },
                      ],
                      class: [_vm.isHotCollapsed ? "btn-hide" : "btn-show"],
                      on: {
                        click: function ($event) {
                          return _vm.toggleCollapsed(
                            "hot-over-cell",
                            "isHotCollapsed"
                          )
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "collapsed-icon",
                        attrs: {
                          src: require("../../image/search/arrow-down.png"),
                          width: "12px",
                          height: "7px",
                        },
                      }),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _vm._t("result-footer"),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }